export default __webpack_public_path__ + "static/media/Rectangle.4c554265.svg";